import React, { useState, useContext, useEffect } from 'react';
import Modal from 'components/modal';
import styled from 'styled-components';
import Stepper from './stepper';
import MainContent from './order-modal/index';
import { ThemeContext } from 'context/themeContext';
import ChatBox from './order-modal/chat-box';
import ShippingInfo from './order-modal/shipping-info';
import { OrderBody, OrderBodyHelper } from './order-modal/css';
import { ProWrapper } from 'components/wrapper/pro-wrapper';
import Attachments from './order-modal/attachments';
import MainContext from 'MainContext';
import { deleteAttachment } from '../container/api';
import { useTranslation } from 'react-i18next';
import ThumbNail from "asset/thumbnail-3d-model-order.svg";
import {
  DownloadWrapper
} from './order-modal/css';

const Wrapper = styled.div`
  width: 100%;
  min-height: ${(props) => (props.status ? '52.256vw' : '46.53vw')};
  box-sizing: border-box;
  padding-right:${(props) => props.rtlDirection ? 'unset' : '3.644vw'};
  margin-left:${(props) => props.rtlDirection ? '3.644vw' : 'unset'};
  position: relative;
  overflow: hidden;
  color: white;
`;

const Image = styled.div`
  width: 100%;
  height: 19.469vw;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  border-top-left-radius: 2.08vw;
  border-top-right-radius: 2.08vw;
  img {
    height: 100%;
  }
`;

const CloseIcon = styled.div`
  position: fixed;
  right:5vw;
  z-index:101;
  cursor:pointer;

  display: flex;
  justify-content: center;
  color: #FFF;
  font-size: 2.4vw;
`;

export const DownloadIcon = styled.div`
  width: 1.1vw;
  height: 1.1vw;
  position: relative;
  transition: background-color 200ms linear;

  align-items: center;
  display: flex;
  justify-content: center;
  color: #FFF;
  font-size: 1.2vw;
`;

const LayerWrapper = styled.div`
  position:absolute;
  width: 100%;
  height: 19.469vw;
  background-image:linear-gradient(360deg, #686868 0%, rgba(255, 255, 255, 0.00) 100%);
`;

const ThumbNailImage = styled.img.attrs({
  src: ThumbNail,
})`
  width: 100%;
  height: 19.469vw;
  background-color: #959595;
  border-top-left-radius: 2.08vw;
  border-top-right-radius: 2.08vw;
`;

const OrderModal = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { updateToasterContext } = useContext(MainContext).toasters;
  const { getAttachFileContext } = useContext(MainContext).orders;
  const { adminType } = useContext(MainContext).login.shop_profile;
  const {
    open,
    toggle,
    selectedOrder,
    invoiceId,
    selectedInvoice,
    updateOpenOrder 
  } = props;
  const [rightClickId, setRightClickId] = useState(-1);
  const [leftRightClick, setLeftRightClick] = useState(0);
  const [showRightClick, setShowRightClick] = useState(false);

  const onContextMenu = (e, id) => {
    e.preventDefault();
    setShowRightClick(true);
    setRightClickId(id);
    if (rtlDirection) {
      setLeftRightClick((100 * e.clientX) / (window.innerWidth) - 45);
    } else {
      setLeftRightClick((100 * e.clientX) / (window.innerWidth) - 32);
    }

    return false;
  };

  const onCloseDeleteAttachment = () => {
    setShowRightClick(false);
    setRightClickId(0);
  }


  const onDeleteAttachment = (e, id) => {
    e.stopPropagation();
    deleteAttachment(id).then(() => {
      
      
      getAttachFileContext(selectedOrder._id)
      setShowRightClick(false);
      setRightClickId(0);
      updateToasterContext({
        type: 'success',
        message: `${t('dashboard.order modal.The attached file was successfully deleted.')}`,
      })
    }).catch(() => {
      setShowRightClick(false);
      setRightClickId(0);
      updateToasterContext({
        type: 'error',
        message: `${t('dashboard.order modal.The attachment was not deleted successfully.')}`,
      })
    })
  }

  useEffect(() => {
    setShowRightClick(false);
    setRightClickId(0);
  }, [open])

  return (
    <>
      {open && <CloseIcon className="icon-close" theme={theme} onClick={toggle} />}
      <Modal open={open} toggle={toggle} selectedOrder={selectedOrder} invoiceId={invoiceId}>
        <Wrapper open={open} onClick={onCloseDeleteAttachment} rtlDirection={rtlDirection}>
          {selectedOrder.file && (
            <Image>
              <LayerWrapper />
              <a href={`${process.env.REACT_APP_STATISTIC_SERVICE_URL}/stl/${selectedOrder.file.original_file_path}?original_name=${selectedOrder.file.original_name}`} >
                <DownloadWrapper onClick={(e) => e.stopPropagation()} theme={theme} rtlDirection={rtlDirection} top={16}>
                  <DownloadIcon className="icon-second-download" theme={theme} />
                </DownloadWrapper>
              </a>
              {
                selectedOrder.file.image_path === "default image path" ? <ThumbNailImage /> :
                  <img
                    src={
                      `${process.env.REACT_APP_STATISTIC_SERVICE_URL}/stl` + selectedOrder.file.image_path
                    }
                  />
              }
            </Image>
          )}

          <OrderBody>
            <OrderBodyHelper>
              {props.selectedOrder.file &&
               <MainContent
                selectedOrder={props.selectedOrder} />}
              {
                adminType !== 1 &&  
                  <Attachments
                  onContextMenu={onContextMenu}
                  rightClickId={rightClickId}
                  showRightClick={showRightClick}
                  leftRightClick={leftRightClick}
                  onDeleteAttachment={onDeleteAttachment}
                  attachedFiles={props.attachedFiles}
                  selectedOrder={selectedOrder}
                  invoiceId={invoiceId}
                  updateOpenOrder={updateOpenOrder}
                   />
              }
              <ProWrapper>
                {
                  selectedOrder.status === 6 && <ShippingInfo selectedOrder={selectedOrder} invoiceId={invoiceId} />
                }
                <ChatBox
                  open={open}
                  selectedOrder={selectedOrder}
                  invoiceId={invoiceId}
                  updateOpenOrder={updateOpenOrder}
                  />
              </ProWrapper>
            </OrderBodyHelper>
          </OrderBody>
        </Wrapper>
      </Modal>
    </>
  );
};

export default OrderModal;
